LS.modal = {
	/**
	 * Open a new modal
	 *
	 * @param {Object} options
	 */
	open(options) {
		const scope = this;

		scope.visible = true;

		LS.util.crop();

		scope.options = Object.assign({
			width: 420
		}, options);

		// Create modal structure if not available
		if (! scope.modal) {
			scope.$modal = $('<div class="modal $modal" role="dialog" aria-modal="true" aria-labelledby="modal-title" aria-hidden="true"/>');
			scope.$inner = $('<div class="modal__inner"/>');
			scope.$mask = $('<div class="modal-mask"/>');

			scope.$modal
				.append(scope.$inner);

			$(document.body)
				.append(scope.$modal)
				.append(scope.$mask);

			scope.modal = scope.$modal[0];
		} else if (scope.visible) {
			scope.modal.classList.add('-is-loading');
		}

		if (options.modifier) {
			scope.modal.classList.add(options.modifier);
		}

		scope.$mask.on('click', () => {
			if ($.screen.size() > 1) {
				scope.close();
			}
		}, {
			namespace: 'modal'
		});

		scope.$mask.addClass('-is-loading -is-visible');

		if (options.model !== null) {
			scope.load(options);
		}

		$(document).on('keydown', e => {
			if (e.keyCode === 27) {
				scope.close();
			}
		}, {
			namespace: 'modal'
		});
	},

	/**
	 * Load new content into an existing modal
	 *
	 * @param {Object} options
	 */
	load(options) {
		const scope = this;
		const width = options.width;
		const height = options.height;

		if (options.url) {
			$.fetch.request({
				url: options.url,
				post: options.post || false,
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				},
				success: data => {
					scope.show(data, width, height);

					if (options.success) {
						options.success();
					}
				},
				error: () => {
					LS.util.warn('There was an error with the request');

					scope.hide(true);
				}
			});
		} else {
			if (options.model) {
				options.content = $.view.render('modal.view', options.model);
			}

			scope.show(options.content, width, height);

			if (options.success) {
				options.success();
			}
		}
	},

	/**
	 * Display a modal on the page
	 *
	 * @param {*} content
	 * @param {Number} width
	 * @param {Number} height
	 */
	show(content, width, height) {
		const scope = LS.modal; // eslint-disable-line

		scope.visible = true;

		scope.$mask.removeClass('-is-loading')
			.addClass('-is-visible');

		scope.$inner.empty()
			.height(height || '');

		scope.$inner.append(content);

		scope.$close = $$('modalClose');

		scope.$close.on('click', () => {
			scope.close();
		}, {
			namespace: 'modal'
		});

		$.exec(scope.options.onShow);

		scope.$modal.addClass('-is-visible')
			.removeClass('-is-loading');

		$(window).on('resize', () => {
			scope.resize();
		}, {
			init: true,
			namespace: 'modal'
		});

		requestAnimationFrame(() => {
			scope.modal.classList.add('-is-loaded');

			scope.modal.setAttribute('aria-hidden', 'false');
		});

		scope.$inner[0].scrollTop = 0;

		const focusable = $('a, button, input, select, textarea', scope.$inner);

		if (focusable.length) {
			scope.active = document.activeElement;

			LS.util.focus(focusable[0]);
		}
	},

	/**
	 * Resize modal container based on content height
	 */
	resize() {
		const scope = this;

		if (! scope.visible) {
			return;
		}

		const mobile = $.screen.size() < 3;

		scope.$inner.width(
			! mobile && scope.options.width ?
				scope.options.width : ''
		);

		scope.modal.style.top = mobile ?
			0 : Math.max(
				((window.innerHeight - scope.modal.offsetHeight) / 3), 0
			) + 'px';
	},

	/**
	 * Scroll modal content
	 *
	 * @param {Number} value
	 */
	scroll(value) {
		this.$modal.scrollTop(value, true);
	},

	/**
	 * Show confirm prompt
	 *
	 * @param {String} message
	 * @param {Function} fn
	 */
	confirm(message, fn) {
		const scope = this;

		scope.open({
			content: $.view.render('modal.confirm', {
				message: message
			}),
			width: 420
		});

		$(document).on('keydown', e => {
			if (e.keyCode === 13) {
				e.preventDefault();

				scope.close();

				fn();
			}
		}, {
			namespace: 'modal'
		});

		$$('modalConfirm').on('click', () => {
			scope.close();

			fn();
		}, {
			namespace: 'modal'
		});

		$$('modalDeny').on('click', () => {
			scope.close();
		}, {
			namespace: 'modal'
		});
	},

	/**
	 * Close the displayed modal
	 */
	close() {
		const scope = this;

		if (! scope.visible) {
			return;
		}

		$.events.reset('modal');

		scope.hide();
	},

	/**
	 * Hide the displayed modal
	 *
	 * @param {Boolean} [force=false]
	 */
	hide(force) {
		const scope = this;

		if (! scope.visible && ! force) {
			return;
		}

		scope.visible = false;

		scope.$mask.removeClass('-is-visible')
			.on('transitionend', () => {
				if (scope.visible) {
					return;
				}

				scope.$mask.removeClass('-is-visible');
			}, {
				namespace: 'modal',
				once: true
			});

		scope.$modal.add(scope.$close)
			.removeClass('-is-loaded -is-visible ' + (scope.options.modifier || ''));

		scope.modal.setAttribute('aria-hidden', 'false');

		LS.util.uncrop();

		$.exec(scope.options.onHide);

		LS.util.focus(scope.active);
	},

	/**
	 * Check model open state
	 *
	 * @returns {Boolean}
	 */
	opened() {
		return this.visible === true;
	}
};